import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _typeof from "@babel/runtime-corejs3/helpers/typeof";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(source, true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(source)).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import types from 'prop-types';
import { branch, compose, withState, withHandlers, mapProps, setDisplayName } from 'recompose';
var masks = {
  stripNonNumeric: function stripNonNumeric() {
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return (val + '').replace(/[^0-9.,]/g, '');
  }
};
var methods = {
  regex: function regex(mask, val) {
    return (val + '').replace(mask, '');
  },
  function: function _function(mask, val) {
    return mask(val);
  },
  string: function string(mask, val) {
    return masks[mask] ? masks[mask](val) : val;
  }
};
var masked = compose(setDisplayName('behaviour(Masked)'), mapProps(function (_ref) {
  var mask = _ref.mask,
      _onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ["mask", "onChange"]);

  return _objectSpread({}, props, {
    onChange: function onChange(_ref2) {
      var _ref2$target = _ref2.target,
          value = _ref2$target.value,
          target = _objectWithoutProperties(_ref2$target, ["value"]),
          event = _objectWithoutProperties(_ref2, ["target"]);

      var _mask = mask instanceof RegExp ? 'regex' : _typeof(mask);

      var maskedValue = methods[_mask](mask, value);

      _onChange(_objectSpread({
        target: _objectSpread({
          value: maskedValue
        }, target)
      }, event));
    }
  });
}));
var notMasked = compose(setDisplayName('behaviour(NotMasked)'), mapProps(function (_ref3) {
  var mask = _ref3.mask,
      props = _objectWithoutProperties(_ref3, ["mask"]);

  return props;
}));
var uncontrolled = compose(withState('value', 'setValue', ''), withHandlers({
  onChange: function onChange(_ref4) {
    var _onChange2 = _ref4.onChange,
        setValue = _ref4.setValue;
    return function (e) {
      setValue(e.target.value);

      _onChange2(e);
    };
  }
}), masked);
export default compose(branch(function (_ref5) {
  var uncontrolled = _ref5.uncontrolled,
      mask = _ref5.mask;
  return uncontrolled && mask;
}, uncontrolled, branch(function (_ref6) {
  var mask = _ref6.mask,
      onChange = _ref6.onChange;
  return mask && onChange;
}, masked, notMasked)));
export var propTypes = {
  mask: types.oneOfType([types.func, types.string, types.object])
};